/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./../lib/httpClient.ts";
import { Response, SessionUserInfo, Tenant } from "././index.d.ts";

export class User<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description This is a module api, it read data from module database
   *
   * @tags user
   * @name GetTenant
   * @request GET:/user/tenant
   * @secure
   */
  getTenant = (params: RequestParams = {}) =>
    this.http.request<Tenant, Tenant | Response>({
      path: `/user/tenant`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get current user information
   *
   * @tags user
   * @name GetCurrentSession
   * @request GET:/user/session
   * @secure
   */
  getCurrentSession = (params: RequestParams = {}) =>
    this.http.request<SessionUserInfo, SessionUserInfo | Response>({
      path: `/user/session`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
